export class CurrencyConvItem {
  constructor (amount, from, to) {
    this.enable = false
    this.amount = amount || 0
    this.from = from || null
    this.to = to || null
  }

  get name () {
    return `${this.from} to ${this.to}`
  }

  static createFromJson (raw) {
    let obj = new CurrencyConvItem()
    obj = Object.assign(obj, raw)
    return obj
  }
}

export let DefaultConversations = [
  new CurrencyConvItem(0.013, 'INR', 'EUR')
]

export class CurrencyConversationManager {
  constructor () {
    this.all = []
    this.selected = new CurrencyConvItem()
  }

  saveToCache () {
    const raw = JSON.stringify(this)
    window.localStorage.setItem('rza_currency_conversion', raw)
  }

  static fromCache () {
    let manager = new CurrencyConversationManager()
    let raw = window.localStorage.getItem('rza_currency_conversion')

    if (raw) {
      raw = JSON.parse(raw)
      manager.selected = CurrencyConvItem.createFromJson(raw.selected)
      manager.all = raw.all.map((iraw) => { return CurrencyConvItem.createFromJson(iraw) })
    } else {
      manager.all = [...DefaultConversations]
      manager.selected = CurrencyConvItem.createFromJson(manager.all[0])
    }

    return manager
  }
}
